import { browser } from '$app/environment';
export type CSSResizeListener = () => void;

export class CSS {
    private static initialized = false;
    private static screenSize = { width: 0, height: 0 };
    private static listeners: CSSResizeListener[] = [];

    constructor() {
        if (!CSS.initialized && browser) {
            CSS.initialized = true;
            window.addEventListener('resize', CSS.resize);
            CSS.resize(); // Initialize screenSize at start
        }
    }

    static onResize(listener: CSSResizeListener) {
        CSS.listeners.push(listener);
        CSS.resize()
    }

    /**
     * @param minWidth 
     * @param maxWidth 
     * @param startScreenSize 
     * @param endScreenSize 
     * @returns 
     */
    static getWidth(minWidth: number, maxWidth: number, startScreenSize: number, endScreenSize: number): number {
        if (endScreenSize === startScreenSize) {
            throw new Error("startScreenSize and endScreenSize cannot be the same.");
        }

        // Ensure that the screen width is within the range we're interested in
        const screenWidth = Math.max(startScreenSize, Math.min(CSS.screenSize.width, endScreenSize));

        // Calculate the slope and intercept for linear interpolation
        const slope = (maxWidth - minWidth) / (endScreenSize - startScreenSize);
        const intercept = minWidth - (slope * startScreenSize);

        // Calculate and return the interpolated width
        return (slope * screenWidth) + intercept;
    }

    private static resize() {
        CSS.screenSize.width = window.innerWidth;
        CSS.screenSize.height = window.innerHeight;
        CSS.listeners.forEach(listener => listener());
    }
}

let init = new CSS()